export default __webpack_public_path__ + "static/media/linkedin.c2542ac0.svg";